export default __webpack_public_path__ + "static/media/hhie-card.ba00e83c.jpg";